import type { RasterImageId } from "@/generated/raster-images";
import { rasterLcpPreloadLink } from "@/lib/lcp-preload";
import heroAshpAsset from "@/assets/air-source-heat-pumps/hero-ashp.jpg.asset.json";
import heroLoftAsset from "@/assets/loft-insulation/hero-loft.jpg.asset.json";
import heroIwiAsset from "@/assets/internal-wall-insulation/hero-iwi.jpg.asset.json";
import heroWallTiesAsset from "@/assets/remedial-wall-ties/hero-wall-ties.jpg.asset.json";
import heroHeatingControlsAsset from "@/assets/heating-controls/hero-heating-controls.jpg.asset.json";
import heroCommercialRetrofit from "@/assets/commercial-retrofit/hero-commercial-retrofit.webp";
import hero1600 from "@/assets/damp-survey/hero-house-1600.webp";

export const SERVICE_RASTER_LCP: Partial<Record<string, RasterImageId>> = {
  "/solar-pv": "solar-pv/hero-solar",
  "/commercial-solar-pv": "commercial-solar-pv/hero-commercial-solar",
  "/commercial-damp-mould-ventilation": "commercial-damp-mould-ventilation/hero-commercial-damp-mould",
};

const SERVICE_ASSET_LCP: Partial<Record<string, string>> = {
  "/air-source-heat-pumps": heroAshpAsset.url,
  "/loft-insulation": heroLoftAsset.url,
  "/internal-wall-insulation": heroIwiAsset.url,
  "/remedial-wall-ties": heroWallTiesAsset.url,
  "/heating-controls": heroHeatingControlsAsset.url,
  "/boiler-upgrade-scheme": heroAshpAsset.url,
  "/damp-survey": hero1600,
  "/for-trade": heroCommercialRetrofit,
  "/commercial": heroCommercialRetrofit,
};

export function serviceLcpPreloadLinks(path: string) {
  const rasterId = SERVICE_RASTER_LCP[path];
  if (rasterId) return [rasterLcpPreloadLink(rasterId)];
  const href = SERVICE_ASSET_LCP[path];
  if (!href) return [];
  const isAvif = href.endsWith(".avif");
  const isWebp = href.endsWith(".webp");
  return [{ rel: "preload" as const, as: "image" as const, href, ...(isAvif ? { type: "image/avif" } : isWebp ? { type: "image/webp" } : {}), fetchPriority: "high" as const }];
}

export function withServiceLcpPreload<T extends { links?: unknown[] }>(path: string, head: T): T {
  const extra = serviceLcpPreloadLinks(path);
  if (extra.length === 0) return head;
  return { ...head, links: [...(head.links ?? []), ...extra] };
}
